export default [
  {
    id: 1,
    avartar: 'https://s3.amazonaws.com/uifaces/faces/twitter/justinrob/128.jpg',
    email: 'Leora13@yahoo.com',
    firstName: 'Ernest Schuppe Anderson',
    lastName: null,
    city: 'New Gust',
    street: 'Dickinson Keys',
    cityRowSpan: 3,
    streetRowSpan: 2,
    zipCode: '17026-3154',
    date: '2016-09-23T07:57:40.195Z',
    bs: 'global drive functionalities',
    catchPhrase: 'Intuitive impactful software',
    company: 'Lebsack - Nicolas',
    words: 'saepe et omnis',
    sentence: 'Quos aut sunt id nihil qui.'
  },
  {
    id: 2,
    avartar: 'https://s3.amazonaws.com/uifaces/faces/twitter/thaisselenator_/128.jpg',
    email: 'Mose_Gerhold51@yahoo.com',
    firstName: 'Janis',
    lastName: 'Bode',
    city: 'New Gust',
    street: 'Dickinson Keys',
    zipCode: '43767',
    date: '2017-03-06T09:59:12.551Z',
    bs: 'e-business maximize bandwidth',
    catchPhrase: 'De-engineered discrete secured line',
    company: 'Glover - Hermiston',
    words: 'deleniti dolor nihil',
    sentence: 'Illo quidem libero corporis laborum.'
  },
  {
    id: 3,
    avartar: 'https://s3.amazonaws.com/uifaces/faces/twitter/arpitnj/128.jpg',
    city: 'New Gust',
    email: 'Frieda.Sauer61@gmail.com',
    firstName: 'Makenzie Vandervort',
    lastName: null,
    street: 'Legros Divide',
    zipCode: '54812',
    date: '2016-12-08T13:44:26.557Z',
    bs: 'plug-and-play e-enable content',
    catchPhrase: 'Ergonomic 6th generation challenge',
    company: 'Williamson - Kassulke',
    words: 'quidem earum magnam',
    sentence: 'Nam qui perferendis ut rem vitae saepe.'
  },
  {
    id: 4,
    avartar: 'https://s3.amazonaws.com/uifaces/faces/twitter/brajeshwar/128.jpg',
    email: 'Eloisa.OHara@hotmail.com',
    firstName: 'Ciara',
    lastName: 'Towne',
    city: 'Vandervort',
    street: 'Mosciski Estate',
    cityRowSpan: 4,
    streetRowSpan: 2,
    zipCode: '76315-2246',
    date: '2016-07-19T12:54:30.994Z',
    bs: 'extensible innovate e-business',
    catchPhrase: 'Upgradable local model',
    company: 'Hilpert, Eichmann and Brown',
    words: 'exercitationem rerum sit',
    sentence: 'Qui rerum ipsa atque qui.'
  },
  {
    id: 5,
    avartar: 'https://s3.amazonaws.com/uifaces/faces/twitter/dev_essentials/128.jpg',
    email: 'Brisa46@hotmail.com',
    firstName: 'Suzanne',
    lastName: 'Wolff',
    city: 'Vandervort',
    street: 'Mosciski Estate',
    zipCode: '88870-3897',
    date: '2017-02-23T17:11:53.875Z',
    bs: 'back-end orchestrate networks',
    catchPhrase: 'Exclusive human-resource knowledge base',
    company: 'Mayer - Considine',
    words: 'voluptatum tempore at',
    sentence: 'Enim quia deleniti molestiae aut.'
  },
  {
    id: 6,
    avartar: 'https://s3.amazonaws.com/uifaces/faces/twitter/petrangr/128.jpg',
    email: 'Cody.Schultz56@gmail.com',
    firstName: 'Alessandra',
    lastName: null,
    city: 'Vandervort',
    street: 'Kali Spurs',
    streetRowSpan: 2,
    zipCode: '81514',
    date: '2016-06-30T05:23:18.734Z',
    bs: 'sexy evolve technologies',
    catchPhrase: 'Virtual hybrid throughput',
    company: 'Nikolaus and Sons',
    words: 'alias minus repudiandae',
    sentence: 'Sed qui eius excepturi sunt voluptates.'
  },
  {
    id: 7,
    avartar: 'https://s3.amazonaws.com/uifaces/faces/twitter/knilob/128.jpg',
    email: 'Enrico_Beer@yahoo.com',
    firstName: 'Margret',
    lastName: 'Heller',
    city: 'Vandervort',
    street: 'Kali Spurs',
    zipCode: '17423-9317',
    date: '2017-03-13T21:09:47.253Z',
    bs: 'wireless morph synergies',
    catchPhrase: 'Profit-focused radical help-desk',
    company: 'Corwin, Maggio and Wintheiser',
    words: 'temporibus possimus neque',
    sentence: 'Eum amet ea non natus qui assumenda illo officia qui.'
  },
  {
    id: 8,
    avartar: 'https://s3.amazonaws.com/uifaces/faces/twitter/tom_even/128.jpg',
    email: 'Mitchel.Herman@yahoo.com',
    firstName: 'Emiliano',
    lastName: 'Moore',
    city: 'Gilberthaven',
    street: null,
    cityRowSpan: 2,
    zipCode: '33930-7081',
    date: '2016-03-27T07:26:57.345Z',
    bs: 'customized integrate e-tailers',
    catchPhrase: 'Total system-worthy contingency',
    company: 'Gulgowski - Botsford',
    words: 'deleniti ipsa hic',
    sentence: 'Ducimus id quaerat neque.'
  },
  {
    id: 9,
    avartar: 'https://s3.amazonaws.com/uifaces/faces/twitter/chandlervdw/128.jpg',
    city: 'Gilberthaven',
    email: 'Gaylord_Reichel16@yahoo.com',
    firstName: 'Alessandra',
    lastName: 'Smith',
    street: 'Kali Spurs',
    zipCode: '01370',
    date: '2017-01-24T22:11:53.835Z',
    bs: 'extensible repurpose action-items',
    catchPhrase: 'Virtual dedicated definition',
    company: 'Maggio LLC',
    words: 'libero unde est',
    sentence: 'Non adipisci hic laboriosam et qui laudantium aspernatur.',
    stars: 330,
    followers: 590
  }
];
